import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { CheckoutPage, getCheckoutPages } from "../../../apis/Admin";
import Button from "../../atoms/Button";
import CheckoutPageItem from "../../atoms/CheckoutPageItem";
import ConfigCheckoutPage from "../../organisms/ConfigCheckoutPage";
import Modal from "../Modal";

interface ListCheckoutPagesProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

interface Item {
  id: string;
  videoPromotionURL: string;
  priceTotal: number;
  discountPercentage: number;
  updatedAt?: number;
}

const ListCheckoutPages = ({
  isOpen,
  onRequestClose,
}: ListCheckoutPagesProps) => {
  const [items, setItems] = useState<Item[]>([]);
  const [configModal, setConfigModal] = useState<{
    show: boolean;
    checkoutId?: string;
  }>({ show: false });

  useEffect(() => {
    const unsubscribe = getCheckoutPages((data) => {
      setItems(data);
    });
    return () => unsubscribe();
  }, []);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        title="Pasarelas de Pago"
      >
        <Container>
          <ActionsWrapper>
            <Button
              type="primary"
              label="Nuevo"
              onClick={() => setConfigModal({ show: true })}
            />
          </ActionsWrapper>
          {items.map((item) => (
            <CheckoutPageItem
              key={item.id}
              id={item.id}
              videoPromotionURL={item.videoPromotionURL}
              priceTotal={item.priceTotal}
              discountPercentage={item.discountPercentage}
              updatedAt={item.updatedAt}
              onClick={(checkoutId) =>
                setConfigModal({ show: true, checkoutId })
              }
            />
          ))}
        </Container>
      </Modal>

      <ConfigCheckoutPage
        isOpen={configModal.show}
        checkoutId={configModal.checkoutId}
        onRequestClose={() => setConfigModal({ show: false })}
      />
    </>
  );
};
const Container = styled.div`
  & > *:not(:last-child) {
    margin-bottom: ${4 * 4}px;
  }
`;

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default ListCheckoutPages;
